<template>
  <div
    v-bind:style="{
      display: displayBetweenDateBox ? `flex` : 'block',
    }"
    v-bind:class="
      displayBetweenDateBox ? `date-box-group multi-line` : 'date-box-group'
    "
  >
    <div class="date-from">
      <DxDateBox
        display-format="dd MMM yyyy"
        :value="dateValue"
        ref="date-from-value"
        @valueChanged="fromDateValueChange"
        :showClearButton="true"
        @enter-key="onPressEnterKey"
      >
        <DxDateBoxButton
          :options="searchTypes"
          name="search"
          location="before"
        />

        <!-- <DxDateBoxButton
          name="clear-btn"
          :options="dateInClearBtn"
          location="after"
        /> -->

        <DxDateBoxButton name="clear" location="after" />
        <DxDateBoxButton name="dropDown" />

        <template #date-in-clear>
          <div>
            <span class="dx-clear-button-area" @click="clearDate"
              ><span class="dx-icon dx-icon-clear"></span
            ></span>
          </div>
        </template>

        <template #show-drop-down>
          <div>
            <DxDropDownButton
              class="search-option"
              icon="equal"
              :show-arrow-icon="false"
              styling-mode="text"
              :items="filterDateRangeOptions()"
              keyExpr="value"
              displayExpr="text"
              :drop-down-options="{ width: 250 }"
              :onItemClick="searchOptionItemClick.bind(this)"
              :useSelectMode="true"
              :selectedItemKey="selectedOperator"
              name="search-drop-down"
              width="25"
            />
          </div>
        </template>
      </DxDateBox>
    </div>

    <div class="date-to" v-if="displayBetweenDateBox">
      <span>To</span>
      <DxDateBox
        display-format="dd MMM yyyy"
        :showClearButton="true"
        :min="toMinValue"
        @valueChanged="toDateValueChange"
        ref="date-to-value"
        :value="dateToValue"
        @enter-key="onPressEnterKey"
      >
      </DxDateBox>
    </div>
  </div>
</template>
<script>
import {
  DxDateBox,
  DxButton as DxDateBoxButton,
} from "devextreme-vue/date-box";

export default {
  components: {
    DxDateBox,
    DxDateBoxButton,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    dateBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    onPressEnterKey: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      searchTypes: {
        template: "show-drop-down",
        elementAttr: { class: "search-option-drop-down" },
        visible:
          this.dateBoxOptions[0].formLocation == "form-report" ? false : true,
      },
      searchOptionItems: [
        { icon: "equal", text: "Equals", value: "=" },
        { icon: "less", text: "Less than", value: "<" },
        { icon: "greater", text: "Greater than", value: ">" },
        { icon: "lessorequal", text: "Less than or equal to", value: "<=" },
        {
          icon: "greaterorequal",
          text: "Greater than or equal to",
          value: ">=",
        },
        { icon: "range", text: "Between", value: "between" },
      ],
      displayBetweenDateBox: false,
      dateValue: undefined,
      dateToValue: undefined,
      selectedOperator: undefined,
    };
  },
  mounted() {
    this.selectedOperator = "=";
    if (this.dateBoxOptions[0].defaultValue) {
      if (Object.keys(this.dateBoxOptions[0].defaultValue).length > 0) {
        this.dateValue = this.dateBoxOptions[0].defaultValue.from;
        this.dateToValue = this.dateBoxOptions[0].defaultValue.to;
        this.selectedOperator = "between";
        this.displayBetweenDateBox = true;
      } else this.dateValue = this.dateBoxOptions[0].defaultValue;
      if (this.dateBoxOptions[0].filterOperator)
        this.selectedOperator = this.dateBoxOptions[0].filterOperator;
      this.createDateRangeFilterValue();
    }
  },
  methods: {
    fromDateValueChange(e) {
      this.dateValue = e.value;

      this.dateToValue = undefined;
      this.createDateRangeFilterValue();
    },
    toDateValueChange(e) {
      this.dateToValue = e.value;
      this.createDateRangeFilterValue();
    },
    clearDate() {
      this.dateValue = undefined;

      var datebox = this.$refs["date-from-value"].instance;
      datebox.reset();
    },
    filterDateRangeOptions() {
      return this.searchOptionItems;
    },
    searchOptionItemClick(e) {
      if (this.$refs["date-to-value"]) {
        this.dateValue = undefined;
        var datebox = this.$refs["date-to-value"].instance;
        datebox.reset();

        var fromdatebox = this.$refs["date-from-value"].instance;
        fromdatebox.reset();
      }

      this.selectedOperator = e.itemData.value;

      if (e.itemData.value == "between") this.displayBetweenDateBox = true;
      else this.displayBetweenDateBox = false;

      if (this.dateValue) {
        this.createDateRangeFilterValue();
      }
    },
    setDateUtcFilterValue(
      filter,
      dateValue,
      dateToValue,
      dateBoxOptions,
      selectedOperator
    ) {
      var setFilter = [];
      let startDateUtc = new Date(dateValue).localStarDateTimeInUTC();

      setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = ">=";
      setFilter[2] = startDateUtc;

      filter.push(setFilter);
      filter.push("and");

      let endDateUtc = startDateUtc.addDays(1);

      if (selectedOperator == "between") {
        endDateUtc = new Date(dateToValue).localStarDateTimeInUTC().addDays(1);
      }

      setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = "<";
      setFilter[2] = endDateUtc;

      filter.push(setFilter);
    },
    setDateNonUtcFilterValue(
      filter,
      dateValue,
      dateToValue,
      dateBoxOptions,
      selectedOperator
    ) {
      var setFilter = [];
      let date = new Date(dateValue).toYYYYMMDD();
      setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = ">=";
      setFilter[2] = new Date(date + "T00:00:00");
      filter.push(setFilter);
      filter.push("and");

      let setNextDay = new Date(selectedOperator == "between" ? dateToValue : dateValue).addDays(1).toYYYYMMDD();
      setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = "<";
      setFilter[2] = new Date(setNextDay + "T00:00:00");
      filter.push(setFilter);
    },
    setDateNonUtcFilterValueSingle(
      filter,
      dateValue,
      dateBoxOptions,
      selectedOperator
    ) {
      let date = new Date(dateValue);
      // let date = this.dateValue;
      let setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = selectedOperator;

      if (selectedOperator == "<") {
        // setFilter[1] = "<";
        setFilter[2] = date.toFilterDateStartTime(); // .addGMTHours(5,30);
        // setFilter[2] = date;
      } else if (selectedOperator == ">") {
        // setFilter[1] = ">";
        setFilter[2] = date.toFilterDateEndTime();
      } else if (selectedOperator == "<=") {
        // setFilter[1] = "<=";
        setFilter[2] = date.toFilterDateEndTime();
      } else if (selectedOperator == ">=") {
        // setFilter[1] = ">=";
        setFilter[2] = date.toFilterDateStartTime();
      }

      filter.push(setFilter);
    },
    setDateUtcFilterValueSingle(
      filter,
      dateValue,
      dateBoxOptions,
      selectedOperator
    ) {
      let date = new Date(dateValue);

      let setFilter = [];
      setFilter[0] = dateBoxOptions[0].dataField;
      setFilter[1] = selectedOperator;

      if (selectedOperator == "<") {
        // setFilter[1] = "<";
        setFilter[2] = date.localStarDateTimeInUTC(); // .addGMTHours(5,30);
        // setFilter[2] = date;
      } else if (selectedOperator == ">") {
        // setFilter[1] = ">";
        setFilter[2] = date.localEndDateTimeInUTC();
      } else if (selectedOperator == "<=") {
        // setFilter[1] = "<=";
        setFilter[2] = date.localEndDateTimeInUTC();
      } else if (selectedOperator == ">=") {
        // setFilter[1] = ">=";
        setFilter[2] = date.localStarDateTimeInUTC();
      }

      filter.push(setFilter);
    },
    createDateRangeFilterValue() {
      let filter = [];

      if (!this.dateValue) {
        this.valueChangeCallBack(this.dateBoxOptions[0].dataField, []);
        return;
      }

      if (this.selectedOperator == "=" || this.selectedOperator == "between") {
        if (this.selectedOperator == "between") if (!this.dateToValue) return;

        if (this.dateBoxOptions[0].dateVariant === "UTC") {
          this.setDateUtcFilterValue(
            filter,
            this.dateValue,
            this.dateToValue,
            this.dateBoxOptions,
            this.selectedOperator
          );
        } else {
          this.setDateNonUtcFilterValue(
            filter,
            this.dateValue,
            this.dateToValue,
            this.dateBoxOptions,
            this.selectedOperator
          );
        }
      } else {
        if (this.dateBoxOptions[0].dateVariant === "UTC") {
          this.setDateUtcFilterValueSingle(
            filter,
            this.dateValue,
            this.dateBoxOptions,
            this.selectedOperator
          );
        } else {
          this.setDateNonUtcFilterValueSingle(
            filter,
            this.dateValue,
            this.dateBoxOptions,
            this.selectedOperator
          );
        }
      }

      if (this.dateBoxOptions[0].formLocation == "form-report") {
        this.valueChangeCallBack(
          this.dateBoxOptions[0].dataField,
          this.dateValue
        );
      } else this.valueChangeCallBack(this.dateBoxOptions[0].dataField, filter);
    },
  },
  computed: {
    selectedOperatorComputed() {
      return this.selectedOperator;
    },
    toMinValue() {
      return new Date(this.dateValue).addDays(1);
    },
    dateInClearBtn() {
      return {
        icon: "clear",
        type: "clear",
        template: "date-in-clear",
        elementAttr: { class: "date-in-clear dx-clear-button-area" },
        visible: true,
      };
    },
    hideDateBoxOperator() {
      return false;
    },
  },
};
</script>

<style lang="scss">
.date-box-group {
  //   display: inline-flex;

  .date-to {
    display: inline-flex;
    //   padding-top: 35px;
    span {
      vertical-align: middle;
      align-self: center;
      padding-right: 10px;
      padding-left: 5px;
    }
  }

  .date-in-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;

    .dx-icon-clear {
      color: rgba(117, 117, 117, 0.87);
      background-color: rgba(194, 194, 194, 0.87);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      margin-top: -11px !important;
      width: 22px;
      height: 22px;
      background-position: 0 0;
      background-size: 12px 12px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      line-height: 12px;
    }
    .dx-icon-clear::before {
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      top: 50%;
      margin-top: -6px;
      left: 50%;
      margin-left: -6px;
    }

    .dx-inkripple .dx-inkripple-wave {
      width: 22px !important;
      height: 22px !important;
      opacity: 1 !important;
      top: 3px !important;
      left: 2px !important;
    }
  }

  .date-in-clear:hover,
  .date-in-clear:focus {
    background-color: unset;
  }
  .date-in-clear.dx-state-active {
    background-color: unset;
  }

  //   .date-from .dx-datebox .dx-dropdowneditor-input-wrapper .dx-texteditor-container .dx-texteditor-input-container{
  //       color: rgb(0, 0, 255);
  //     // input.dx-texteditor-input {
  //     //       padding-right: 0 !important;
  //     //   }

  //       .dx-texteditor-input-container .dx-texteditor-input-container{
  //           color: green;
  //                 }

  //                 .dx-texteditor-input{
  //                     color:hotpink
  //                 }
  //   }

  .date-from .dx-texteditor-input-container input.dx-texteditor-input {
    padding-right: 0 !important;
  }

  .date-to .dx-texteditor-input-container input.dx-texteditor-input {
    text-overflow: unset;
  }

  .search-option {
    .dx-button-content {
      // padding-left: 8px !important;
      // padding-right: 8px !important;
      padding: 0 !important;
      .dx-icon {
        margin: 0 !important;
      }
    }
    padding: 0 !important;
  }
  .dx-dropdownbutton {
    height: auto;
  }
}

.date-box-group.multi-line {
  flex-direction: column;

  .date-to {
    padding-top: 10px;

    span.dx-clear-button-area {
      padding-right: 16px;
    }

    .dx-texteditor-container {
      input {
        padding-left: 7px;
      }
    }
  }
}
</style>
